import Space from './forms/Space'
import Map from './forms/Map'

type AdminPlanScreen = (props: AdminPlanFormProps) => JSX.Element | null

const SCREENS: { [key in AdminPlanStep]: AdminPlanScreen } = {
  space: Space,
  map: Map,
}

export { SCREENS }
